import { Component, OnInit, ViewChild } from '@angular/core';
import { PhysiotherapySession, PhysiotherapySessionService } from './physical-therapy-session.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '../../blocks';



@Component({
  selector: 'app-physical-therapy-session',
  templateUrl: './physical-therapy-session.component.html',
  styleUrls: ['./physical-therapy-session.component.css']
})
export class physicalTherapySessionComponent implements OnInit {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  PhysiotherapySession: any[] = [];

  PhysiotherapySessionObject: PhysiotherapySession = <PhysiotherapySession>{};
  dynamicComponent: any;
  actionRowData: any;
  actionCode: number;
  row: any;
  patientInfo: any;
  filterArea: boolean = true;
  private activeAction: any;
  showlist: boolean = true;
  private visitedActions: any = {};
  breadCrumbData: { type: string; code: any; nameAr: any; serviceNameAr: any; areaName: any; };
  PhysiotherapyStepsObject: PhysiotherapySession = <PhysiotherapySession>{};
  PhysiotherapySteps: any[] = [];
   totalTime :number =0;
   remaining: number = 0;
   remainingTime:number ;
  @ViewChild('popup') content: any;
  constructor(
    private _PhysiotherapySessionService: PhysiotherapySessionService,
    public translate: TranslateService,
    private _modalService: ModalService
  ) { }
  ngOnInit() {
    this.getPhysiotherapySession();
  }
  getPhysiotherapySession() {
    this._PhysiotherapySessionService
      .getPhysiotherapySession(
        this.PhysiotherapySessionObject
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        this.PhysiotherapySession = res.data;

      });
  }
  getPhysiotherapySteps() {
    this.totalTime = 0;
    this.remaining=0;
    this.remainingTime=0;
    this.PhysiotherapyStepsObject.visitSerial = this.row.visitSerial;
    this.PhysiotherapyStepsObject.patCode = this.row.code;
    this._PhysiotherapySessionService
      .getPhysiotherapySteps(
        this.PhysiotherapyStepsObject
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        this.PhysiotherapySteps = res.data;
        this.PhysiotherapySteps.forEach(ele =>{
          this.totalTime += ele.timeInMinutes;
          this.remaining += ele.remainingTime;
          this.remainingTime = this.totalTime-this.remaining;
        } )
      });
  }
updatePhysiotherapySteps(item){
  this._PhysiotherapySessionService.updatePhysiotherapySteps(item)
  .pipe(takeUntil(this.ngUnsubscribe))
  .subscribe((res) => {
  });
}

  onSearchClick(_searchObj: any) {
    this.PhysiotherapySessionObject.dateFrom = _searchObj.ngbFromDateStr;
    this.PhysiotherapySessionObject.dateTo = _searchObj.ngbToDateStr;
    this.PhysiotherapySessionObject.docCode = _searchObj.DocCode;
    this.PhysiotherapySessionObject.patCode = _searchObj.patCode;
    this.getPhysiotherapySession();

  }
  setBreadCrumb(type: string, code, nameAr?, serviceNameAr?, areaName?) {
    this.breadCrumbData = Object.assign({},
      { type: type, code: code, nameAr: nameAr, serviceNameAr: serviceNameAr, areaName: areaName });
  }

  getActiveAction(_row: any, appCodes: any[]) {
    let activeActions = [];
    activeActions = appCodes;
    return activeActions;
  }
  onIconActionClick(action: any, rowData: any) {

    this.actionCode = action.serial;
    action['code'] = action.serial;
    if (this.actionCode != 6587) {
      if (this.actionCode != (404 || 2330 || 2331 || 2332 || 2333 || 6509 || 6520)) {
        this.setBreadCrumb('in', this.actionCode, `( ${rowData['fullnameAr']} ) `
          , ` ${rowData['serviceNameAr']} `, null);
      }
      else {
        this.setBreadCrumb('in', this.actionCode, '', '', null);
      }
      this.visitedActions[action.serial] = true;
      this.activeAction = action.serial;
      if (this.activeAction != undefined) {
        this.showlist = false;
        this.row = rowData;
      }
    }
    this.getPhysiotherapySteps();
  }
  onActionIconsClicked(ActionSerial: any, row: any) {
    this.actionRowData = row;
    if (ActionSerial == 6500) { // open documents upload
      console.log('docserv => ', row);
      this.dynamicComponent = 3
      this.content.openModal("FilesUploadComponent", "FilesUpload", row);
    }
  
  }
 
  onBtnsClicked(e) {
    switch (e) {
      case 2260:
        break;
      case 2:
        this.back()
    }
  }
  back() {
    this.showlist = true;

    this.getPhysiotherapySession();
  }

  checkboxChanged(item,element) {

    this._modalService.activeMes(`هل انت  متاكد `, `Are You Sure `).then(responseOK => {
      if (responseOK) {
        this.updatePhysiotherapySteps(item)
      }
      else {
      element.target.checked= !element.target.checked;
      }
      this.getPhysiotherapySteps() 
    })
 
  }


}